import React from 'react';
import { Container, Paper, Typography, Box, List, ListItem, ListItemText } from '@mui/material';

const PrivacyPolicy = () => {
    return (
        <Container maxWidth="md">
            <Paper elevation={3} sx={{ p: 4, mt: 4, mb: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Datenschutzerklärung
                </Typography>

                <Typography component="p">
                    Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </Typography>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h6">1. Verantwortliche Stelle</Typography>
                    <Typography component="p">
                        Ruhr-Universität Bochum<br />
                        Universitätsstraße 150, 44801 Bochum
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h6">2. Erhebung und Speicherung personenbezogener Daten</Typography>
                    <Typography component="p">
                        Das "Observatorium" dient der Verwaltung eines Teilnehmerpools für wissenschaftliche Studien.
                        Wenn Sie sich registrieren, erheben wir folgende Daten, um passende Studien für Sie zu finden:
                    </Typography>
                    <List dense>
                        <ListItem><ListItemText primary="E-Mail-Adresse & Passwort (gehasht und gesalzen)" /></ListItem>
                        <ListItem><ListItemText primary="Demografische Daten wie Geburtsjahr, Wohnort, Geschlecht" /></ListItem>
                        <ListItem><ListItemText primary="Physische Merkmale wie Größe und Gewicht)" /></ListItem>
                        <ListItem><ListItemText primary="Sozioökonomische Daten wie Beruf, Einkommen und Beziehungsstatus" /></ListItem>
                    </List>
                    <Typography component="p">
                        Die detaillierten Informationen sind nötig, um Teilnehmende so auszuwählen, dass Studien repräsentative Ergebnisse liefern. Das Observatorium garantiert eine entsprechende Auswahl,
                        ohne die Daten selbst den Forschenden zugänglich zu machen. Die im Profil gespeicherten Informationen werden ausschließlich durch automatisierte Filter genutzt und nicht an Dritte
                        weitergegeben.
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h6">3. Datensicherheit und Anonymität</Typography>
                    <Typography component="p">
                        Ihre Daten werden auf der Infrastruktur der Ruhr-Universität Bochum gehostet.
                        Wir verwenden moderne Hashing- und Salting-Verfahren für Passwörter.
                    </Typography>
                    <Typography component="p">
                        Besonders wichtig: <strong>Ihre persönlichen Kontaktdaten werden niemals direkt an die durchführenden Forscher weitergegeben.</strong>
                        Das System generiert anonyme Identifikationscodes. Forscher sehen lediglich aggregierte Zahlen oder anonymisierte Filtergruppen, um Einladungen zu versenden.
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h6">4. Ihre Rechte</Typography>
                    <Typography component="p">
                        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default PrivacyPolicy;